import identitySelectors from "./identity";

const can = (permission: string) => () => {
  const permissions = identitySelectors.permissions();
  if (permissions === "*") return true;
  if (permissions === null) return false;
  if (permissions === undefined) return false;
  return permissions.includes(permission);
};

export const permissionsSelectors = {
  can,
};
export default permissionsSelectors;
